import { useEffect } from 'react';
import { useUserContext } from '../context/UserContext';
import { useSecurityContext } from '../context/SecurityContext';

export default (): void => {
  const { fetchProfile } = useUserContext();
  const { accessToken, organizationId } = useSecurityContext();

  useEffect(() => {
    if (accessToken && organizationId) {
      fetchProfile();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken, organizationId]);
};
